import styled from "styled-components";
import { UsuarioMenuContainer, UsuarioMenuLink } from "../UsuarioMenu/estilo";

interface PropsBarra {
  percentual: number;
  acabando: boolean;
}

interface PropsCodigo {
  expirado: boolean;
}

interface PropsAcao {
  desabilitado?: boolean;
}

interface PropsMensagem {
  erro?: boolean;
}

export const MenuContainer = styled(UsuarioMenuContainer)`
  position: fixed;
  margin-top: 0;
  width: 300px;
  text-align: left;

  hr {
    margin: 16px 0;
  }
`;

export const SelectDespachante = styled.select`
  width: 100%;
  height: 38px;
  padding: 0 8px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.neutral20};
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.neutral.neutral70};
  background-color: #ffffff;
  font-size: 14px;
`;

export const Codigo = styled.div<PropsCodigo>`
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 6px;
  text-align: center;
  color: ${({ theme, expirado }) =>
    expirado ? theme.colors.neutral.neutral30 : theme.colors.success.main};
`;

export const BarraFundo = styled.div`
  height: 6px;
  width: 100%;
  margin: 8px 0 4px 0;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral10};
  overflow: hidden;
`;

export const BarraProgresso = styled.div<PropsBarra>`
  height: 100%;
  width: ${({ percentual }) => percentual}%;
  background-color: ${({ theme, acabando }) =>
    acabando ? theme.colors.danger.main : theme.colors.neutral.neutral80};
`;

export const Contagem = styled.small`
  display: block;
  text-align: center;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.neutral.neutral50};
`;

export const Mensagem = styled.p<PropsMensagem>`
  margin: 16px 0 0 0;
  font-size: 14px;
  color: ${({ theme, erro }) =>
    erro ? theme.colors.danger.main : theme.colors.neutral.neutral50};
`;

export const AcaoLink = styled(UsuarioMenuLink)<PropsAcao>`
  cursor: ${({ desabilitado }) => (desabilitado ? "not-allowed" : "pointer")};
  color: ${({ theme, desabilitado }) =>
    desabilitado ? theme.colors.neutral.neutral30 : theme.colors.neutral.neutral70};

  &:hover {
    color: ${({ theme, desabilitado }) =>
      desabilitado
        ? theme.colors.neutral.neutral30
        : theme.colors.neutral.neutral70} !important;
  }

  i,
  svg {
    width: 16px;
    margin-right: 4px;
  }
`;
